// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.card {
    background-color: #f2f2f2;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 6px 10px;
    /* margin-bottom: 8px; */
}

/* .emptyState {
	margin: 0 0 8px 0;
	padding: 0;
	color: #888;
	font-size: 14px;
} */

/* Single source of truth for the Controls / Automations / Messages empty
   states. All three render <p class="emptyState"> with no per-screen
   override, so the placeholder text lands at the exact same (x, y) on every
   tab. padding-left ~= a row/card's text offset (1px border + 10px padding);
   min-height + centered flex fix the vertical baseline across tabs. */
.emptyState {
    display: flex;
    align-items: center;
    min-height: 26px;      /* matches .row */
    margin: 0 0 8px 0;     /* matches .itemRow */
    padding: 0 0 0 11px;   /* left-align shared by all three tabs */
    color: #888;
    font-size: 14px;
}

/* .input_screen {
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	margin: 0px 0px;
	padding-left: 24px;
	display: flex;
	flex-direction: column;
} */


.input_screen {
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	margin: 0px 0px;
	padding-left: 24px;
}


@media (max-width: 768px) {
	.input_screen {
		padding-left: 0;
	}
}

#data_menu {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 4px;
}

.data_screen {
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
}

#graph_box {
	flex: 1;
	min-height: 0;
}

.data_screen {
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
	position: relative;   /* add this line — anchors the bottom-right Clean up button */
}`, "",{"version":3,"sources":["webpack://./code/styles/screens.css"],"names":[],"mappings":";;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;;;;;GAKG;;AAEH;;;;sEAIsE;AACtE;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB,OAAO,iBAAiB;IACxC,iBAAiB,MAAM,qBAAqB;IAC5C,mBAAmB,IAAI,wCAAwC;IAC/D,WAAW;IACX,eAAe;AACnB;;AAEA;;;;;;;;GAQG;;;AAGH;CACC,OAAO;CACP,aAAa;CACb,gBAAgB;CAChB,eAAe;CACf,kBAAkB;AACnB;;;AAGA;CACC;EACC,eAAe;CAChB;AACD;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,kBAAkB;AACtB;;AAEA;CACC,OAAO;CACP,aAAa;CACb,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,OAAO;CACP,aAAa;AACd;;AAEA;CACC,OAAO;CACP,aAAa;CACb,aAAa;CACb,sBAAsB;CACtB,kBAAkB,IAAI,6DAA6D;AACpF","sourcesContent":["\n\n.card {\n    background-color: #f2f2f2;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    padding: 6px 10px;\n    /* margin-bottom: 8px; */\n}\n\n/* .emptyState {\n\tmargin: 0 0 8px 0;\n\tpadding: 0;\n\tcolor: #888;\n\tfont-size: 14px;\n} */\n\n/* Single source of truth for the Controls / Automations / Messages empty\n   states. All three render <p class=\"emptyState\"> with no per-screen\n   override, so the placeholder text lands at the exact same (x, y) on every\n   tab. padding-left ~= a row/card's text offset (1px border + 10px padding);\n   min-height + centered flex fix the vertical baseline across tabs. */\n.emptyState {\n    display: flex;\n    align-items: center;\n    min-height: 26px;      /* matches .row */\n    margin: 0 0 8px 0;     /* matches .itemRow */\n    padding: 0 0 0 11px;   /* left-align shared by all three tabs */\n    color: #888;\n    font-size: 14px;\n}\n\n/* .input_screen {\n\tflex: 1;\n\tmin-height: 0;\n\toverflow-y: auto;\n\tmargin: 0px 0px;\n\tpadding-left: 24px;\n\tdisplay: flex;\n\tflex-direction: column;\n} */\n\n\n.input_screen {\n\tflex: 1;\n\tmin-height: 0;\n\toverflow-y: auto;\n\tmargin: 0px 0px;\n\tpadding-left: 24px;\n}\n\n\n@media (max-width: 768px) {\n\t.input_screen {\n\t\tpadding-left: 0;\n\t}\n}\n\n#data_menu {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-bottom: 4px;\n}\n\n.data_screen {\n\tflex: 1;\n\tmin-height: 0;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n#graph_box {\n\tflex: 1;\n\tmin-height: 0;\n}\n\n.data_screen {\n\tflex: 1;\n\tmin-height: 0;\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: relative;   /* add this line — anchors the bottom-right Clean up button */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
